export function formatDate(date) {
  if (!date) return null;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return Number(`${year}${month}${day}`);
}

/**
 * Valida se as datas de início e fim estão preenchidas e se a inicial não é maior que a final.
 * Retorna { valido: boolean, mensagem: string|null }
 */
export function validarPeriodoRelatorio(dataInicio, dataFim) {
  if (!dataInicio || !dataFim) {
    return { valido: false, mensagem: 'Preencha as datas de início e fim do relatório.' };
  }
  if (formatDate(dataInicio) > formatDate(dataFim)) {
    return { valido: false, mensagem: 'A data de início não pode ser posterior à data final.' };
  }
  return { valido: true, mensagem: null };
}

const DataUtils = { formatDate, validarPeriodoRelatorio };

export default DataUtils;
